import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16707 4.99996C4.70684 4.99996 4.33374 5.37305 4.33374 5.83329V11.5C4.33374 11.9602 4.70683 12.3333 5.16707 12.3333H12.1671C12.6273 12.3333 13.0004 11.9602 13.0004 11.5V5.83329C13.0004 5.37305 12.6273 4.99996 12.1671 4.99996H5.16707ZM3.33374 5.83329C3.33374 4.82077 4.15455 3.99996 5.16707 3.99996H12.1671C13.1796 3.99996 14.0004 4.82078 14.0004 5.83329V11.5C14.0004 12.5125 13.1796 13.3333 12.1671 13.3333H5.16707C4.15456 13.3333 3.33374 12.5125 3.33374 11.5V5.83329Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00041 2.66663C6.27655 2.66663 6.50041 2.89048 6.50041 3.16663V5.49996C6.50041 5.7761 6.27655 5.99996 6.00041 5.99996C5.72426 5.99996 5.50041 5.7761 5.50041 5.49996V3.16663C5.50041 2.89048 5.72426 2.66663 6.00041 2.66663Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3337 2.66663C11.6099 2.66663 11.8337 2.89048 11.8337 3.16663V5.49996C11.8337 5.7761 11.6099 5.99996 11.3337 5.99996C11.0576 5.99996 10.8337 5.7761 10.8337 5.49996V3.16663C10.8337 2.89048 11.0576 2.66663 11.3337 2.66663Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33374 7.16663C5.33374 6.89048 5.5576 6.66663 5.83374 6.66663H11.5004C11.7765 6.66663 12.0004 6.89048 12.0004 7.16663C12.0004 7.44277 11.7765 7.66663 11.5004 7.66663H5.83374C5.5576 7.66663 5.33374 7.44277 5.33374 7.16663Z"
      fill="currentColor"
    />
  </SvgIcon>
));
